const isSearchBot = () => {
  const botPattern =
    '(apis-google|mediapartners-google|adsbot|googlebot|bingbot|yandex|baiduspider|twitterbot|facebookexternalhit|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkShare|W3C_Validator)';
  const re = new RegExp(botPattern, 'i');
  return re.test(window.navigator.userAgent);
};

export default isSearchBot;
